{
	"swatch": "{{color}}-swatch"
}
